import React from "react";
import "../Stylesheets/WaiverButton.css";
import smartWaiverLogo from "../Media/smartwaiver_logo.png"

export default function WaiverButton({
 
  href  ,
  title = "Sign the Waiver",
  subtitle = "Tap to continue",
  sameTab = true,
  className = "",
}) {
  return (
    <div className={`wb-wrap ${className}`}>
      <a
        className="wb-btn"
        href={href}
         rel={sameTab ? undefined : "noreferrer"}
      >

        <img className="wb-sw-logo" src={smartWaiverLogo}/>  
        <div className="wb-left">
 
          <div className="wb-sub">{subtitle}</div>
        </div>



 
      </a>
    </div>
  );
}
